import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14.5 3H3v3H2v1h1v3H2v1h1v3H2v1h1v3h11.5c1.378 0 2.5-1.122 2.5-2.5v-10C17 4.122 15.878 3 14.5 3zm0 1c.827 0 1.5.673 1.5 1.5v10c0 .827-.673 1.5-1.5 1.5H4v-2h1v-1H4v-3h1v-1H4V7h1V6H4V4h10.5zM13 13H7c0-1.657 1.58-2 3-2s3 .343 3 2zm-3-6c-.828 0-1.5.672-1.5 1.5S9.172 10 10 10s1.5-.672 1.5-1.5S10.828 7 10 7z',
  ],
  height: 20,
  width: 20,
});
